import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {BrowserStorageService} from './services/browser-storage/browser-storage.service';
import {AuthenticationInterceptor} from './interceptor/authentication/authentication.interceptor';
import {AuthenticationService} from './services/authentication/authentication.service';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginatorIntl} from './mat-custom-settings/paginator/custom-paginator-intl';

registerLocaleData(localeDe);
export const appConfig: ApplicationConfig = {
    providers: [
        BrowserStorageService,
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes),
        provideClientHydration(),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withFetch(),
        ),
        AuthenticationService,
        {provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true},
        {provide: LOCALE_ID, useValue: 'de-DE'},
        { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    ]
};
